import { useState } from "react"

// Shared step-navigation/draft-saving state machine used by both the EP1001
// (PatentFormPage) and EP1200 (PatentEpPhaseFormPage) forms — the two pages
// build very different save/reset payloads, but the loading-guard and
// silent-autosave-on-navigation behavior around them is identical.
export function useDraftStep(isLocked: boolean) {
  const [step, setStep] = useState(0)
  const [savingDraft, setSavingDraft] = useState(false)

  const runSaving = async (action: () => Promise<void>) => {
    if (savingDraft || isLocked) return
    setSavingDraft(true)
    try {
      await action()
    } finally {
      setSavingDraft(false)
    }
  }

  const goToStep = async (
    index: number,
    autoSave: () => Promise<unknown>,
    hasUnsavedContent: boolean
  ) => {
    if (index === step) return
    setStep(index)
    window.scrollTo({ top: 0, behavior: "smooth" })

    if (!isLocked && !savingDraft && hasUnsavedContent) {
      await runSaving(async () => {
        try {
          await autoSave()
        } catch {
          /* keep navigating — the in-memory form state is untouched */
        }
      })
    }
  }

  return { step, setStep, savingDraft, goToStep, runSaving }
}
